const HIDDEN_STORE_PRODUCT_HANDLES = new Set(['omega-3-kwfm', 'vitamin-d3-k2-ol-kwfm']);
const HIDDEN_STORE_PRODUCT_IDS = new Set(['11106622636359', '11106634268999']);

function hiddenStoreProductHomeUrl() {
  return window.Shopify?.routes?.root || '/';
}

function isHiddenStoreProductUrl(url) {
  const value = String(url || '').toLowerCase();
  if (!value) return false;

  for (const handle of HIDDEN_STORE_PRODUCT_HANDLES) {
    if (value.includes(`/products/${handle}`)) return true;
  }

  return false;
}

function isHiddenStoreProductPath(pathname) {
  const value = String(pathname || window.location.pathname || '').toLowerCase();
  return Array.from(HIDDEN_STORE_PRODUCT_HANDLES).some((handle) =>
    value.includes(`/products/${handle}`)
  );
}

function redirectHiddenStoreProductPage() {
  if (!isHiddenStoreProductPath()) return;
  window.location.replace(hiddenStoreProductHomeUrl());
}

function replaceHiddenProductLink(link) {
  if (!link || link.dataset.hiddenStoreProductLink === 'processed') return;
  const href = link.getAttribute('href') || '';
  if (!isHiddenStoreProductUrl(href)) return;

  link.dataset.hiddenStoreProductLink = 'processed';

  const card = link.closest(
    '.product-card-wrapper, .card-wrapper, .menu_product_info, .predictive-search__list-item, .grid__item, .splide__slide, .complementary-slide, li'
  );
  if (card && !card.closest('.cart-item, cart-notification-product, #CartDrawer, #main-cart-items')) {
    card.remove();
    return;
  }

  if (link.classList.contains('cart-item__link')) {
    link.remove();
    return;
  }

  const replacement = document.createElement('span');
  replacement.className = link.className;
  replacement.innerHTML = link.innerHTML;
  link.replaceWith(replacement);
}

function stripHiddenStoreProductLinks(root = document) {
  if (!root?.querySelectorAll) return;

  root.querySelectorAll('a[href*="/products/"]').forEach((link) => {
    replaceHiddenProductLink(link);
  });
}

function observeHiddenStoreProductLinks() {
  const targets = [
    document.body,
    document.getElementById('CartDrawer'),
    document.getElementById('main-cart-items'),
    document.querySelector('cart-notification'),
  ].filter(Boolean);

  if (!targets.length || typeof MutationObserver === 'undefined') return;

  const observer = new MutationObserver(() => {
    stripHiddenStoreProductLinks(document);
  });

  targets.forEach((target) => {
    observer.observe(target, { childList: true, subtree: true });
  });
}

function initHiddenStoreProducts() {
  redirectHiddenStoreProductPage();
  stripHiddenStoreProductLinks(document);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      window.requestAnimationFrame(() => {
        stripHiddenStoreProductLinks(document);
      });
    });
  }

  observeHiddenStoreProductLinks();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHiddenStoreProducts, { once: true });
} else {
  initHiddenStoreProducts();
}
